export enum SimType {
  PHYSICAL = 'physical',
  ESIM = 'esim',
}
